<template>
  <div class="appointment-container">
    <div class="btn-group">
      <a class="btn btn-outline-primary" :href="appointmentUrl" target="_blank">Open appointments in new tab</a>
    </div>

    <b-embed class="appointment-frame" :src="appointmentUrl" aspect="1by1"></b-embed>
  </div>
</template>

<script>
import courses from 'components/courses/settings'

export default {
  name: 'Appointment',
  data () {
    return {
      appointmentUrl: null,
      courseId: null
    }
  },
  watch: {
    '$route.params': {
      immediate: true,
      deep: true,
      handler: function (params) {
        this.courseId = params['courseId']
        this.appointmentUrl = courses[this.courseId]['appointment']
      }
    }
  }
}
</script>

<style lang="stylus">
  @import "~assets/colors.styl"

  .appointment-container {
    .appointment-frame {
      background-color $grey
    }
    .btn-group {
      float right
      margin-top -20px
      margin-bottom 10px
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/global/submodule/Appointment.vue